import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VProgressCircular,{attrs:{"indeterminate":""}}),_c('Overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }